module.exports = __webpack_public_path__ + "img/climbing-flying-icon.46ebc0f4.svg";